import dayjs from "dayjs";

export const EVENT_TYPES = [
  { value: "HOLIDAY", label: "Holiday" },
  { value: "EVENT", label: "Event" },
];

export function eventType(item) {
  return String(item?.type || "HOLIDAY").toUpperCase() === "EVENT" ? "EVENT" : "HOLIDAY";
}

export function eventTypeLabel(item) {
  return eventType(item) === "EVENT" ? "Event" : "Holiday";
}

export const HOLIDAY_AUDIENCES = [
  { value: "BOTH", label: "Teachers & students" },
  { value: "STUDENT", label: "Students only" },
  { value: "TEACHER", label: "Teachers only" },
];

export function audienceLabel(audience = "BOTH") {
  return HOLIDAY_AUDIENCES.find((item) => item.value === audience)?.label || "Teachers & students";
}

export function holidayAudience(item) {
  return item?.audience || "BOTH";
}

export function holidayStart(item) {
  return dayjs(item?.date).startOf("day");
}

export function holidayEnd(item) {
  if (item?.endDate) {
    return dayjs(item.endDate).startOf("day");
  }
  return holidayStart(item);
}

export function holidayCoversDay(item, day) {
  const target = dayjs(day).startOf("day");
  if (!target.isValid() || !holidayStart(item).isValid()) return false;
  return !target.isBefore(holidayStart(item)) && !target.isAfter(holidayEnd(item));
}

export function holidayDayCount(item) {
  const start = holidayStart(item);
  const end = holidayEnd(item);
  if (!start.isValid() || !end.isValid()) return 0;
  return end.diff(start, "day") + 1;
}

export function formatHolidayRange(item) {
  const start = holidayStart(item);
  const end = holidayEnd(item);
  if (!start.isValid()) return "—";
  if (start.isSame(end, "day")) return start.format("MMMM D, YYYY");
  if (start.year() === end.year()) {
    return `${start.format("MMM D")} – ${end.format("MMM D, YYYY")}`;
  }
  return `${start.format("MMM D, YYYY")} – ${end.format("MMM D, YYYY")}`;
}

export function holidaysByDate(holidays) {
  const map = {};
  holidays.forEach((item) => {
    if (!holidayStart(item).isValid()) return;
    let cursor = holidayStart(item);
    const end = holidayEnd(item);
    while (!cursor.isAfter(end)) {
      const key = cursor.format("YYYY-MM-DD");
      if (!map[key]) map[key] = [];
      if (!map[key].some((entry) => entry._id === item._id)) {
        map[key].push(item);
      }
      cursor = cursor.add(1, "day");
    }
  });
  return map;
}

export function holidaysInMonth(holidays, monthCursor) {
  const monthStart = monthCursor.startOf("month");
  const monthEnd = monthCursor.endOf("month");
  return holidays
    .filter((item) => {
      const start = holidayStart(item);
      const end = holidayEnd(item);
      return !end.isBefore(monthStart, "day") && !start.isAfter(monthEnd, "day");
    })
    .sort((a, b) => holidayStart(a).valueOf() - holidayStart(b).valueOf());
}

export function upcomingHolidays(holidays, today = dayjs().startOf("day")) {
  return holidays
    .filter((item) => !holidayEnd(item).isBefore(today, "day"))
    .sort((a, b) => holidayStart(a).valueOf() - holidayStart(b).valueOf());
}

export function upcomingAfterMonth(holidays, monthHolidays, today = dayjs().startOf("day")) {
  const monthIds = new Set(monthHolidays.map((item) => item._id));
  return upcomingHolidays(holidays, today).filter((item) => !monthIds.has(item._id));
}

export function isMultiDayHoliday(item) {
  return holidayDayCount(item) > 1;
}

export function isHolidayStartDay(item, day) {
  return holidayStart(item).isSame(dayjs(day).startOf("day"), "day");
}

export function isHolidayEndDay(item, day) {
  return holidayEnd(item).isSame(dayjs(day).startOf("day"), "day");
}

export function audienceClassName(audience = "BOTH") {
  return `is-audience-${String(audience).toLowerCase()}`;
}
